import { apiSlice } from './apiSlice';

export const bannerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBanners: builder.query({
      query: (params) => ({
        url: '/banners',
        params,
      }),
      providesTags: ['Banner'],
    }),

    getBanner: builder.query({
      query: (id) => `/banners/${id}`,
      providesTags: (result, error, id) => [{ type: 'Banner', id }],
    }),

    createBanner: builder.mutation({
      query: (formData) => ({
        url: '/banners',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Banner'],
    }),

    updateBanner: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/banners/${id}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [
        'Banner',
        { type: 'Banner', id },
      ],
    }),

    toggleBannerStatus: builder.mutation({
      query: (id) => ({
        url: `/banners/${id}/toggle`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Banner'],
    }),

    deleteBanner: builder.mutation({
      query: (id) => ({
        url: `/banners/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Banner'],
    }),
  }),
});

export const {
  useGetBannersQuery,
  useGetBannerQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useToggleBannerStatusMutation,
  useDeleteBannerMutation,
} = bannerApi;